import { Observable } from 'rxjs/internal/Observable';
import { filter } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Breadcrumb } from './breadcrumb.model';
import { BreadcrumbConfig } from './breadcrumb.config';
import { GenerateBreadcrumbUseCase } from './use-case/generate-breadcrumb.use-case';
import { GenerateBreadcrumbUseCaseResponse } from './use-case/generate-breadcrumb.use-case-response';
import { NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'pw-breadcrumbmodule',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

    breadcrumbItems: Breadcrumb[] = [];

    constructor(
        private _generateBreadcrumbUseCase: GenerateBreadcrumbUseCase,
        private _config: BreadcrumbConfig,
        private _router: Router
    ) {}

    ngOnInit(): void {
        this._reloadBreadcrumbOnNavigationChange();
    }

    private _reloadBreadcrumbOnNavigationChange(): void {
        this._router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(() => {
            this._loadBreadcrumbItems();
        });
    }

    private _loadBreadcrumbItems(): void {
        (
            this._generateBreadcrumbUseCase.execute(
                {
                    navigationMenuConfigPath: this._config.navigationMenuConfigPath as string
                }
            ) as Observable<GenerateBreadcrumbUseCaseResponse>
        )
        .subscribe(
            (generateBreadcrumbUseCaseResponse) => {
                this.breadcrumbItems = generateBreadcrumbUseCaseResponse.breadcrumbItems;
            }
        );
    }
}
